export default {
  SET_KANBAN_UI_FLAG: 'SET_KANBAN_UI_FLAG',
  SET_FUNNELS: 'SET_FUNNELS',
  SET_FUNNEL: 'SET_FUNNEL',
  ADD_FUNNEL: 'ADD_FUNNEL',
  UPDATE_FUNNEL: 'UPDATE_FUNNEL',
  DELETE_FUNNEL: 'DELETE_FUNNEL',
  SET_FUNNEL_CUSTOM_FIELDS: 'SET_FUNNEL_CUSTOM_FIELDS',
  SET_FUNNEL_STAGES: 'SET_FUNNEL_STAGES',
  ADD_FUNNEL_STAGE: 'ADD_FUNNEL_STAGE',
  UPDATE_FUNNEL_STAGE: 'UPDATE_FUNNEL_STAGE',
  DELETE_FUNNEL_STAGE: 'DELETE_FUNNEL_STAGE',
  SET_FUNNEL_ITEMS: 'SET_FUNNEL_ITEMS',
  MERGE_FUNNEL_ITEMS: 'MERGE_FUNNEL_ITEMS',
  RESET_STAGE_ITEMS: 'RESET_STAGE_ITEMS',
  UPSERT_STAGE_ITEMS: 'UPSERT_STAGE_ITEMS',
  SET_STAGE_META: 'SET_STAGE_META',
  ADD_FUNNEL_ITEM: 'ADD_FUNNEL_ITEM',
  UPDATE_FUNNEL_ITEM: 'UPDATE_FUNNEL_ITEM',
  SET_FUNNEL_ITEM_POSITIONS: 'SET_FUNNEL_ITEM_POSITIONS',
  UPDATE_ITEM_CONVERSATION: 'UPDATE_ITEM_CONVERSATION',
  DELETE_FUNNEL_ITEM: 'DELETE_FUNNEL_ITEM',
  SET_SCHEDULED_MESSAGES: 'SET_SCHEDULED_MESSAGES',
  RESET_SCHEDULED_TIMELINE: 'RESET_SCHEDULED_TIMELINE',
  UPSERT_SCHEDULED_MESSAGES_PAGE: 'UPSERT_SCHEDULED_MESSAGES_PAGE',
  SET_SCHEDULED_META: 'SET_SCHEDULED_META',
  SET_SCHEDULED_FILTERS: 'SET_SCHEDULED_FILTERS',
  SET_SCHEDULED_UI: 'SET_SCHEDULED_UI',
  ADD_SCHEDULED_MESSAGE: 'ADD_SCHEDULED_MESSAGE',
  UPDATE_SCHEDULED_MESSAGE: 'UPDATE_SCHEDULED_MESSAGE',
  DELETE_SCHEDULED_MESSAGE: 'DELETE_SCHEDULED_MESSAGE',
  SET_ACTIVE_FUNNEL_ID: 'SET_ACTIVE_FUNNEL_ID',
  SET_VIEW_MODE: 'SET_VIEW_MODE',
  SET_SAVED_VIEWS: 'SET_SAVED_VIEWS',
  SET_FUNNEL_STATS: 'SET_FUNNEL_STATS',
  ADD_SAVED_VIEW: 'ADD_SAVED_VIEW',
  UPDATE_SAVED_VIEW: 'UPDATE_SAVED_VIEW',
  DELETE_SAVED_VIEW: 'DELETE_SAVED_VIEW',
  SET_VIEW_FILTERS: 'SET_VIEW_FILTERS',
  RESET_VIEW_FILTERS: 'RESET_VIEW_FILTERS',
  SET_VIEW_BOOTSTRAP: 'SET_VIEW_BOOTSTRAP',
  RESET_VIEW_BOOTSTRAP: 'RESET_VIEW_BOOTSTRAP',
  SET_WAHA_INBOXES: 'SET_WAHA_INBOXES',
  SET_REMOTE_ACTIVITY: 'SET_REMOTE_ACTIVITY',
  CLEAR_REMOTE_ACTIVITY: 'CLEAR_REMOTE_ACTIVITY',
};
